import React from "react";
import { Modal, Button } from "react-bootstrap";

/**
 * const handleDelete = () => {
 *     console.log("Item deleted ✅");
 *     setShowConfirm(false);
 *   };
 *
 *   return (
 *     <div>
 *       <h3>Custom Confirm Panel Demo</h3>
 *       <Button variant="danger" onClick={() => setShowConfirm(true)}>
 *         Delete Item
 *       </Button>
 *
 *       <ConfirmPanel
 *         show={showConfirm}
 *         title="Delete Item"
 *         message="This action cannot be undone. Do you really want to delete?"
 *         onConfirm={handleDelete}
 *         onCancel={() => setShowConfirm(false)}
 *       />
 *     </div>
 *   );
 *
 *
 * @param show
 * @param title
 * @param message
 * @param onConfirm
 * @param onCancel
 * @returns {Element}
 * @constructor
 */

export const ConfirmPanel = ({ show, title, message, onConfirm, onCancel }) => {
    return (
        <Modal show={show} onHide={onCancel} centered>
            <Modal.Header closeButton>
                <Modal.Title>{title || "Confirm Action"}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <p>{message || "Are you sure you want to continue?"}</p>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onCancel}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={onConfirm}>
                    Confirm
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
